import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { RootState } from '../../../types/common.types';

import { useExternalRegistrationApi } from '../../../api/external-registration/useExternalRegistrationApi';
import { useRegistrationApi } from '../../../api/registration/useRegistrationApi';

import Activate from '../../../components/screens/auth/activate/Activate';

const ActivateContainer = () => {
  const memberStatus = useSelector((state: RootState) => state.registration.memberStatus);

  const [programmeName, setProgrammeName] = useState<string | undefined>(undefined);

  const { memberExternalReference } = useParams();

  const { registerSystemUser } = useRegistrationApi();

  const { verifyMemberStatus } = useExternalRegistrationApi();

  useEffect(() => {
    verifyMemberStatus({ memberExternalReference: memberExternalReference! });
  }, [verifyMemberStatus, memberExternalReference]);

  const createSystemUser = (username: string, password: string) => {
    registerSystemUser({ username, password, memberExternalReference: memberExternalReference! }, (name) =>
      setProgrammeName(name)
    );
  };

  return <Activate createSystemUser={createSystemUser} programmeName={programmeName} memberStatus={memberStatus} />;
};

export default ActivateContainer;
